module.exports = __webpack_public_path__ + "media/images/org-social-media-icon-2efaf7a6.svg";